<template>
  <div class="general-frame">
    <div class="general-neick">
      <div class="general-search-bar">
        <span>厕所类型</span>
        <el-select
          style="width: 100%; width: 130px; margin: 0px 10px"
          v-model="toiletType"
        >
          <el-option label="传统厕所" value="1"></el-option>
          <el-option label="真空厕所" value="2"></el-option>
        </el-select>
        <el-button
          type="primary"
          class="elm-but"
          icon="el-icon-search"
          @click="getList()"
          >搜索</el-button
        >
        <el-button
          type="primary"
          class="elm-but"
          style="margin-left: 15px"
          :loading="loading"
          @click="resetData()"
          icon="el-icon-refresh"
          >重置</el-button
        >
      </div>
      <div>
        <table class="surface">
          <thead>
            <tr>
              <th>厕所名称</th>
              <th>人流量(人)</th>
              <th>用水量(吨)</th>
              <th>男女比例</th>
              <th>能耗(kw)</th>
              <th>巡检</th>
              <th>运维</th>
              <th>类型</th>
              <th>厕所照片</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.sumPeo }}</td>
              <td>{{ item.sunWater.toFixed(3) }}</td>
              <td>
                {{
                  "男" +
                  ((item.numM * 100) / (item.numM + item.numW) || 0).toFixed(
                    0
                  ) +
                  "% / 女" +
                  ((item.numW * 100) / (item.numM + item.numW) || 0).toFixed(
                    0
                  ) +
                  "%"
                }}
              </td>
              <td>{{ item.sumEle }}</td>
              <td>{{ item.inspection }}</td>
              <td>{{ item.operation }}</td>
              <td>{{ item.toiletType === 1 ? "智慧厕所" : "真空厕所" }}</td>
              <td>{{ item.images == null ? "暂无" : item.images }}</td>
              <td class="color_button" v-if="item.toiletType == 1">
                <router-link
                  :to="{ path: '/toiletDetail', query: { id: item.id } }"
                >
                  <el-button
                    type="success"
                    style="margin-right: 5px"
                    size="small"
                    >查看</el-button
                  >
                </router-link>
                <el-button
                  @click="show_wh(item)"
                  type="primary"
                  style="margin-left: 5px"
                  size="small"
                  >维护</el-button
                >
              </td>
              <td class="color_button" v-if="item.toiletType == 2">
                <router-link
                  :to="{ path: '/toiletDetail2', query: { id: item.id } }"
                >
                  <el-button
                    type="success"
                    style="margin-right: 5px"
                    size="small"
                    >查看</el-button
                  >
                </router-link>
                <el-button
                  @click="show_wh(item)"
                  style="color: #fff; margin-left: 5px"
                  type="primary"
                  size="small"
                  >维护</el-button
                >
              </td>
            </tr>
            <el-dialog
              title="公厕信息维护"
              :visible.sync="dialogVisible"
              width="40%"
              :before-close="handleClose"
              class="formdialog"
            >
              <el-form
                :model="ruleForm"
                status-icon
                :rules="rules"
                ref="ruleForm"
                label-width="120px"
                class="demo-ruleForm"
              >
                <el-form-item label="公厕名称：" prop="name">
                  <el-input
                    style="width: 180px"
                    v-model="ruleForm.name"
                  ></el-input>
                </el-form-item>
                <el-form-item label="厕所类型：" prop="type">
                  <input
                    style="margin-right: 5px; width: 18px; height: 18px"
                    type="radio"
                    name="radios"
                    value="1"
                    v-model="ruleForm.toiletType"
                  /><span style="margin-right: 20px">智慧厕所</span>
                  <input
                    style="margin-right: 5px; width: 18px; height: 18px"
                    type="radio"
                    name="radios"
                    value="2"
                    v-model="ruleForm.toiletType"
                  /><span style="margin-right: 20px">真空厕所</span>
                  <input
                    style="margin-right: 5px; width: 18px; height: 18px"
                    type="radio"
                    name="radios"
                    value="3"
                    v-model="ruleForm.toiletType"
                  /><span style="margin-right: 20px">传统厕所</span>
                </el-form-item>
                <el-form-item label="管理人员：" prop="principal">
                  <span>{{ruleForm.principal}}</span>
                  <el-dropdown  @command="handleCommand">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      circle
                    ></el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="item.id" v-for="(item,index) in persions" :key="index">{{item.realName}},{{item.id}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item label="联系电话：" prop="contact">
                 <span>{{ruleForm.phone ||'暂无'}}</span>
                </el-form-item>
                <el-form-item label="厕位数量：" prop="occupancyNum">
                  <el-input
                    style="width: 100px"
                    v-model.number="ruleForm.occupancyNum"
                  ></el-input>
                </el-form-item>
                <div class="flex" style="justify-content: flex-start">
                  <el-form-item
                    style="width: 330px"
                    label="公厕经度："
                    prop="lng"
                  >
                    <el-input
                      style="width: 150px"
                      v-model="ruleForm.lng"
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="width: 300px" label="纬度：" prop="lat">
                    <el-input
                      style="width: 150px"
                      v-model="ruleForm.lat"
                    ></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="开放时间：" prop="time">
                  <el-time-select
                    style="width: 130px"
                    placeholder="起始时间"
                    v-model="ruleForm.openTime"
                    :picker-options="{
                      start: '00:00',
                      step: '00:15',
                      end: '10:00',
                    }"
                  >
                  </el-time-select>
                  <el-time-select
                    style="width: 130px"
                    placeholder="结束时间"
                    v-model="ruleForm.closeTime"
                    :picker-options="{
                      start: '15:59',
                      step: '00:15',
                      end: '23:59',
                      minTime: ruleForm.openTime,
                    }"
                  >
                  </el-time-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm()"
                    >提交</el-button
                  >
                  <el-button @click="handleClose()">关闭</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
          </tbody>
          <noData :data="data" />
        </table>
        <el-pagination
          background
          style="text-align: center; margin-top: 15px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageNum"
          layout="prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import noData from "@/components/html/noData";
export default {
  components: {
    noData,
  },
  data() {
    var validatename = (rule, value, callback) => {
      if (value === "" || value.length >= 16) {
        callback(new Error("厕所名称不能为空且长度小于16"));
      } else {
        callback();
      }
    };
    var validatemanager = (rule, value, callback) => {
      if (value === "" || value.length >= 16) {
        callback(new Error("名字不能为空且长度小于16"));
      } else {
        callback();
      }
    };
    var validatephone = (rule, value, callback) => {
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(value)) {
        callback(new Error("手机号码格式不正确"));
      } else {
        callback();
      }
    };
    var validateoccupancyNum = (rule, value, callback) => {
      if (value === "" || !Number.isInteger(value) || value >= 100) {
        callback(new Error("不能为空，且为100内数字"));
      } else {
        callback();
      }
    };
    var validatelng = (rule, value, callback) => {
      if (value === "" || value.length >= 16) {
        callback(new Error("不能为空，且为数字长度不超过16位"));
      } else {
        callback();
      }
    };
    var validatelat = (rule, value, callback) => {
      if (value === "" || value.length >= 16) {
        callback(new Error("不能为空，且为数字长度不超过16位"));
      } else {
        callback();
      }
    };
    return {
      pageSize: 12, //每页10条
      pageNum: 1, //当前页码
      toiletType: null,
      total: 0,
      persions:[{id:null,realName:null}],
      data: null,
      loading: false,
      dialogVisible: false,
      ruleForm: {
        id: null,
        name: "",
        openTime: "",
        lng: null,
        lat: null,
        closeTime: "",
        phone: null,
        manager: null,
        occupancyNum: null,
      },
      rules: {
        name: [{ validator: validatename, trigger: "blur" }],
        manager: [{ validator: validatemanager, trigger: "blur" }],
        phone: [{ validator: validatephone, trigger: "blur" }],
        occupancyNum: [{ validator: validateoccupancyNum, trigger: "blur" }],
        lng: [{ validator: validatelng, trigger: "blur" }],
        lat: [{ validator: validatelat, trigger: "blur" }],
      },
    };
  },

  methods: {
    getList() {
      this.loading = true;
      this.get("/toiletInfo/list", {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        toiletType: this.toiletType,
        isQueryAll: false,
      }).then((res) => {
        this.data = res.data.rows;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    submitForm() {
      //表单事件
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.post("/toiletInfo/edit", this.ruleForm).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: "信息修改成功！",
                type: "success",
              });
            }
          });
        } else {
          this.$message.error("请正确配置信息！");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },

    //维护事件修改厕所信息
    show_wh(e) {
      this.ruleForm = {
        id: null,
        name: "",
        openTime: "",
        lng: null,
        lat: null,
        phone:null,
        closeTime: "",
        manager: null,
        contact: null,
        principal: null,
        occupancyNum: null,
      };
      this.get("/toiletInfo/view", { id: e.id }).then((res) => {
        this.ruleForm = res.data.data;
      });
      this.dialogVisible = true;
    },
    //下拉点击事件
    handleCommand(command) {
      this.ruleForm.manager = command;
       let persionA = this.persions.filter(item=> {
          return item.id == command;
          
        });
        this.ruleForm.principal = persionA[0].realName;
        this.ruleForm.phone = persionA[0].telPhone;

      },
    handleClose() {
      //关闭事件
      this.dialogVisible = false;
    },

    //pageNum  改变时会触发
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(); //调用终端数据接口
    },
    //pageSize改变时会触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },

    //清除
    eliminate(form) {
      this.form.type = null;
      this.$refs.form.resetFields();
    },

    //重置
    resetData() {
      this.toiletType = null;
      this.getList();
    },
  },
  mounted() {
    this.get("user/getUserRecord",{}).then(res=>{
      if(res.status == 200){
        this.persions = res.data.rows;
      }
    })
    this.toiletType = this.$route.query.type ? this.$route.query.type : null;
    this.getList();
  },
};
</script>
<style >
.demo-ruleForm .el-form-item__label,
.demo-ruleForm .el-input__inner,
.demo-ruleForm span {
  font-size: 20px !important;
}
.demo-ruleForm .el-form-item__content {
  float: left;
  margin-left: 20px !important;
}
.formdialog .el-dialog__title {
  font-size: 25px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/menu/toilet/toiletInfo.vue